var map = {
  "./desktop/BetterIndiaArticles.scss": [
    "21835",
    7,
    "9160"
  ],
  "./desktop/index.js": [
    "57825",
    9,
    "9598",
    "76225",
    "62815",
    "35407",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "6260",
    "50279",
    "15660",
    "59189",
    "56280"
  ],
  "./desktop/BetterIndiaArticles": [
    "93101",
    9,
    "9598",
    "47387",
    "3199",
    "88565",
    "27174",
    "6260",
    "50279",
    "15660",
    "59189",
    "54243"
  ],
  "./desktop/index": [
    "57825",
    9,
    "9598",
    "76225",
    "62815",
    "35407",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "6260",
    "50279",
    "15660",
    "59189",
    "56280"
  ],
  "./mobile/BetterIndiaArticles.scss": [
    "5485",
    7,
    "29820"
  ],
  "./mobile/index.js": [
    "90053",
    9,
    "9598",
    "58285",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "15660",
    "88863",
    "12844"
  ],
  "./mobile": [
    "90053",
    9,
    "9598",
    "58285",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "15660",
    "88863",
    "12844"
  ],
  "./desktop": [
    "57825",
    9,
    "9598",
    "76225",
    "62815",
    "35407",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "6260",
    "50279",
    "15660",
    "59189",
    "56280"
  ],
  "./desktop/": [
    "57825",
    9,
    "9598",
    "76225",
    "62815",
    "35407",
    "47387",
    "3199",
    "88565",
    "77996",
    "50437",
    "27174",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "6260",
    "50279",
    "15660",
    "59189",
    "56280"
  ],
  "./mobile/": [
    "90053",
    9,
    "9598",
    "58285",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "15660",
    "88863",
    "12844"
  ],
  "./desktop/BetterIndiaArticles.js": [
    "93101",
    9,
    "9598",
    "47387",
    "3199",
    "88565",
    "27174",
    "6260",
    "50279",
    "15660",
    "59189",
    "54243"
  ],
  "./mobile/BetterIndiaArticles.js": [
    "74786",
    9,
    "9598",
    "47387",
    "88565",
    "6532",
    "15660",
    "88863",
    "80135"
  ],
  "./mobile/index": [
    "90053",
    9,
    "9598",
    "58285",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "6532",
    "15660",
    "88863",
    "12844"
  ],
  "./mobile/BetterIndiaArticles": [
    "74786",
    9,
    "9598",
    "47387",
    "88565",
    "6532",
    "15660",
    "88863",
    "80135"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 37125;
module.exports = __rspack_async_context;
